module.exports = __webpack_public_path__ + "static/media/edit_menu.3b6ac22c.svg";